'use client';

import { Box, Collapse, Link, SpriteIcon, Typography } from '@coolblue-development/freddy';
import selectMoreProductInformationTrigger from '@coolblue-development/ga4-events/triggers/ProductInformation/selectMoreProductInformationTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { useBreakpoints } from '@hooks/useBreakpoints';
import { useTranslation } from '@i18n/useTranslation';

import { useProductInformation } from './ProductInformationContext';

const ProductDescription = ({
  description,
  hideLink = false
}: {
  description: string;
  hideLink?: boolean;
}) => {
  const { t } = useTranslation('webshop.productPage.productInformation');
  const { openModal } = useProductInformation();
  const { isMobile } = useBreakpoints();
  const collapseTranslations = useFreddyTranslations('collapse');
  const lineCount = isMobile ? 10 : 15;
  const { trackEvent } = useAnalytics();
  const params = {
    content: 'show more'
  };

  const handleLinkClick = () => {
    openModal();
    trackEvent(selectMoreProductInformationTrigger(params));
  };

  return (
    <Box>
      <Typography variant='h3' mb={200}>
        {t('description')}
      </Typography>
      {!isMobile ? (
        <Collapse
          collapsedLines={lineCount}
          translations={collapseTranslations}
          onClick={() => trackEvent(selectMoreProductInformationTrigger(params))}
        >
          <Typography component='div' dangerouslySetInnerHTML={{ __html: description }} />
        </Collapse>
      ) : (
        <Box>
          <Typography
            component='div'
            truncateLines={!hideLink ? lineCount : undefined}
            dangerouslySetInnerHTML={{ __html: description }}
          />
          {!hideLink && (
            <Link
              component='button'
              startIcon={<SpriteIcon name='arrow-right' />}
              onClick={handleLinkClick}
            >
              {t('fullDescription')}
            </Link>
          )}
        </Box>
      )}
    </Box>
  );
};

export default ProductDescription;
